(function (angular) {
	'use strict';

	angular
		.module('viewUpdateModule')
		.controller('ViewUpdate', [
			'APP_BASE_PATH',
			'globalConfig',
			'InvestorUpdateFactory',
			'localStorageFactory',
			'urlFactory',
			ViewUpdateFunction
		]);

	function ViewUpdateFunction(
		APP_BASE_PATH,
		globalConfig,
		InvestorUpdateFactory,
		localStorageFactory,
		urlFactory
	) {
		var investorUpdate = this;

		angular.extend(investorUpdate, globalConfig);
		investorUpdate.existingUser = localStorageFactory.getItem('existingUser');
		investorUpdate.basePath = APP_BASE_PATH;
		investorUpdate.loading = true;

		InvestorUpdateFactory.getById(investorUpdate.investorUpdateId).then(function (update) {
				investorUpdate.loading = false;
				investorUpdate.update = update;
			},
			function (response) {
				investorUpdate.error = true;
				investorUpdate.loading = false;
				urlFactory.handleFailedRequest(response);
			});

	}
})(window.angular);